import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/entitlements/entilementBillingActivity/initialState.entitlementBillingActivity.data';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';
import {
  fetchEBillingActivityCPI as fetchEBillingActivityCPIAPI,
  fetchEBillingActivityBilling as fetchEBillingActivityBillingAPI,
} from '../../../../apis/entitlementBillingActivityAPI';
import { ACTIONS_ENTITLEMENT_BILLING_ACTIVITY } from '../../../../constants/actionCreator';
import { handlePending, handleRejection } from '../../../../constants';
import { globalDateFormat } from '../../../../utils/common';

export const fetchEBillingActivityCPI = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_BILLING_ACTIVITY.FETCH_BILLING_ACTIVITY_DATA,
  fetchEBillingActivityCPIAPI
);

export const fetchEBillingActivityBilling = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_BILLING_ACTIVITY.FETCH_BILLING_ACTIVITY_BILLING_DATA,
  fetchEBillingActivityBillingAPI
);

const entitlementBillingActivitySlice = createSlice({
  name: 'entitlementBillingActivity',
  initialState,
  reducers: {
    //Additional Events/Functions capture here
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEBillingActivityCPI.pending, (state, action) => {
        handlePending(state, action);
        state.isLoading = true;
        state.isDataFound = null;
        state.billingActivityCpiData = [];
        state.billingCPITotalCount = 0;
      })
      .addCase(fetchEBillingActivityCPI.fulfilled, (state, action) => {
        state.isDataFound = true;
        state.billingActivityCpiData = action?.payload?.billingActivity?.map(
          (item, index) => {
            item.id = index;
            item.activity_Date = globalDateFormat(item?.activity_Date);
            return item;
          }
        );
        state.billingCPITotalCount = action?.payload?.totalCount || 0;
      })
      .addCase(fetchEBillingActivityCPI.rejected, (state, action) => {
        handleRejection(state, action);
        state.isLoading = true;
        state.isDataFound = false;
        state.billingActivityCpiData = [];
        state.billingCPITotalCount = 0;
      })

      .addCase(fetchEBillingActivityBilling.pending, (state, action) => {
        handlePending(state, action);
        state.isBillingDataLoading = true;
        state.isBIllingDataFound = null;
        state.billingActivityBillingData = [];
      })
      .addCase(fetchEBillingActivityBilling.fulfilled, (state, action) => {
        state.isBillingDataLoading = false;
        state.isBIllingDataFound = action?.payload?.billDetails?.length > 0;
        state.billingActivityBillingData =
          action?.payload?.billDetails
            ?.sort(
              (a, b) =>
                new Date(b.billGenerationDate) - new Date(a.billGenerationDate)
            )
            .sort(
              (a, b) =>
                new Date(b.billingCycleDate) - new Date(a.billingCycleDate)
            ) || [];
        state.billingActivityBillingTotalCount =
          action?.payload?.totalRecords || 0;
      })
      .addCase(fetchEBillingActivityBilling.rejected, (state, action) => {
        handleRejection(state, action);
        state.isBillingDataLoading = false;
        state.isBIllingDataFound = false;
        state.billingActivityBillingData = [];
        state.billingActivityBillingTotalCount = 0;
      });
  },
});

export default entitlementBillingActivitySlice.reducer;
